import React from 'react';
import SideNavWithNavigation from './SideNavWithNavigation';
import './publicSite/PublicPages.css';
import './Management.css';

interface LayoutProps {
  children: React.ReactNode;
  onNavigate?: (page: string) => void;
  currentPage?: string;
}

const LayoutWithNavigation: React.FC<LayoutProps> = ({ children, onNavigate, currentPage }) => {
  return (
    <div className="management-layout flex min-h-screen flex-col md:h-screen md:flex-row md:overflow-hidden">
      <div className="w-full flex-none md:w-64">
        <SideNavWithNavigation onNavigate={onNavigate} currentPage={currentPage} />
      </div>
      <main className="management-main min-w-0 flex-1 p-5 md:overflow-y-auto md:p-10">
        {children}
      </main>
    </div>
  );
};

export default LayoutWithNavigation;
